<template>
  <v-app>
    <v-navigation-drawer v-model="navigationDrawer" temporary app right>
      <v-list-item>
        <v-list-item-icon>
          <picture class="logo img-responsive">
            <img
              class="logo img-responsive fill-height"
              src="@/assets/img/_src/FMSH.svg"
              :alt="title"
            />
          </picture>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ shortTitle }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <template v-for="(item, k) in updatedItems">
          <v-list-group
            v-if="item.items"
            :key="k"
            :prepend-icon="item.icon"
            no-action
            :value="item.value"
            append-icon="fa-caret-down"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="(subItem, i) in item.items">
              <v-list-item
                v-if="!subItem.items"
                link
                :key="`${k}_${i}`"
                :to="subItem.path"
                :value="subItem.value"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-group
                v-else
                no-action
                sub-group
                :key="`${k}_${i}`"
                :value="subItem.value"
                append-icon="fa-caret-down"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="subItem.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(subSubItem, j) in subItem.items"
                  :key="`${k}_${i}_${j}`"
                  link
                  :to="subSubItem.path"
                  :value="subSubItem.value"
                >
                  <v-list-item-title
                    v-text="subSubItem.title"
                  ></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list-group>
          <v-list-item
            v-else
            link
            :key="k"
            :to="item.path"
            color="primary"
            :value="item.value"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <Header>
      <v-btn text fab x-large @click="navigationDrawer = true">
        <v-icon>fas fa-bars</v-icon>
      </v-btn>
    </Header>
    <main :style="mainStyle">
      <router-view />
    </main>
    <Footer />
  </v-app>
</template>

<style type="text/scss">
@import "styles/main.scss";
</style>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { mapGetters } from "vuex";

export default {
  name: "App",

  components: { Footer, Header },

  data() {
    return {
      navigationDrawer: false,
      items: [
        { icon: "fa-home", title: "Главная", path: "/" },
        {
          icon: "fa-info-circle",
          title: "О школе",
          items: [
            { title: "Галерея", path: "/about/gallery" },
            { title: "Мы в СМИ", path: "/about/mass-media" },
            { title: "История", path: "/about/history" },
            { title: "Выпускники", path: "/about/graduates" }
          ]
        },
        {
          title: "Расписание",
          icon: "fa-calendar",
          items: [{ title: "Всё", path: "/schedule/all" }],
          path: "/schedule"
        },
        {
          title: "Лица школы",
          icon: "fa-users",
          path: "/faces"
        },
        {
          title: "Лаборатория НТТ",
          icon: "fa-flask",
          path: "/lab"
        },
        {
          title: "Благодарности",
          icon: "fa-thumbs-up",
          path: "/gratitude"
        },
        {
          title: "Контакты",
          icon: "fa-address-book",
          path: "/contacts"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "title",
      "shortTitle",
      "headerBarHeight",
      "headerPadding",
      "courses"
    ]),
    mainStyle() {
      if (this.headerPadding)
        return { paddingTop: `${this.headerBarHeight}px` };
      return { marginTop: "-8px" };
    },
    updatedItems() {
      return this.items.map(el => {
        if (el.path === "/schedule") {
          el.items = this.courses.map(course => {
            return { title: course.name, path: `/schedule/${course.id}` };
          });
        }
        return el;
      });
    }
  },
  methods: {
    checkInnerMenuOpen(mainItem, to) {
      if (!mainItem.items) {
        let value = !!(mainItem.path && to === mainItem.path);
        mainItem = { ...mainItem, value };
        return mainItem;
      } else {
        mainItem = {
          ...mainItem,
          items: mainItem.items.map(item => this.checkInnerMenuOpen(item, to))
        };
        let value = !!mainItem.items.filter(item => item.value).length;
        mainItem = { ...mainItem, value };
        return mainItem;
      }
    }
  },
  created() {
    this.items = this.items.map(item =>
      this.checkInnerMenuOpen(item, this.$route.path)
    );
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  src: url(./assets/fonts/HelveticaNeue.woff2) format("woff2");
}

@font-face {
  font-family: Helvetica;
  font-weight: 700;
  src: url(./assets/fonts/HelveticaNeue-Bold.woff2) format("woff2");
}

*,
::after,
::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  min-height: 100vh;
}

body {
  font-family: Helvetica, sans-serif !important;
  min-height: 100vh;
}

main {
  position: relative;
  min-height: 85%;
}

img {
  vertical-align: middle;
  border-style: none;
}

.v-navigation-drawer,
.v-navigation-drawer--fixed {
  z-index: 8 !important;
}

.main-image {
  display: none;
}

@media (min-width: 960px) {
  .main-image {
    position: absolute;
    z-index: 0;
    display: inline-block;
    bottom: 7vh;
    right: 10vw;
  }
}

@media (max-width: 959px) {
  .v-main {
    padding-top: 0 !important;
  }
}

::selection {
  background-color: orange;
  color: #fff;
}

.fill-width {
  width: 100%;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}

.video-embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

section.content-main {
  padding: 30px 10px;
  div,
  strong,
  img,
  p {
    z-index: 5;
  }
}
</style>
